// PORTAL Store
import axios from "axios"
import { cacheAdapterEnhancer } from "axios-extensions"

const http = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
    //'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    //'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
  },
  adapter: cacheAdapterEnhancer(axios.defaults.adapter)
})

const state = {
  STATUS: null,
  API_ROUTE: "/dractive",
  doctors: [],
  selectedDoctor: null
}

const getters = {
  doctors: state => {
    return state.doctors.filter(doctor => doctor.State === "FL")
    // .filter((doctor) => doc.id === 6 ) // .find(doctor => doctor.Qualification === "MD" )
  }
}

// Called from Action to change State
const mutations = {
  getDoctors(state, doctors) {
    state.doctors = doctors
  }
}

// Called externally to commit a State Mutation
const actions = {
  async loadDoctors({ commit }, payload) {
    var url = state.API_ROUTE
    //console.log('URL: ' + url)

    await http
      .get(url)
      .then(r => r.data)
      .then(doctors => {
        commit("getDoctors", doctors)
      })
      .catch(function(error) {
        state.STATUS = "An error occurred: " + error
        console.log(state.STATUS)
      })
  },
  logout() {
    this.reset()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
